import { render, staticRenderFns } from "./FabricExample.vue?vue&type=template&id=8dd3a210"
import script from "./FabricExample.vue?vue&type=script&lang=js"
export * from "./FabricExample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports